<template>
    <!-- что важно родителям-->
    <div class="block-parents">
        <div class="block-parents__body">
            <div class="block-parents__content">
                <span class="block-parents__title">Что важно <br> родителям</span>
                <div class="block-parents__box block-parents__box-one">
                    <p class="block-parents__text block-parents__text-one">
                        Кажется, ребенок уже совсем вырос. Но&nbsp;ему все так же нужна помощь взрослых: моральная поддержка во время поступления, финансовая — пока не нашел&nbsp;работу. 
                        <br><br>
                        Экзамены, поступление в колледж или универ заботят родителей не меньше, чем ребенка (а&nbsp;может, даже больше). Кроме&nbsp;этого, им предстоит решить, будут ли они жить вместе или уже взрослому сыну или дочери нужна своя&nbsp;квартира.
                    </p>
                    <BlockParallax
                        fixed
                        speed="20"
                        direction="top"
                        transform="translateY"
                        class="block-parents__img-box block-parents__img-box-one"
                    >
                        <img
                            srcset="../assets/parents-1.jpg, ../assets/parents-1@2x.jpg 2x"
                            src="../assets/parents-1.jpg"
                            class="block-parents__img"
                        >
                        <div class="image-caption">Школа в проекте «Ярославский»</div>
                    </BlockParallax>
                </div>
                <div class="block-parents__box block-parents__box-two">
                    <p class="block-parents__text block-parents__text-two">
                        К совершеннолетию ребенка родители должны научиться двум противоположным вещам: поддерживать и давать полную свободу выбора. Это непросто, но ребенок обязательно оценит. Когда сам станет&nbsp;родителем.
                    </p>
                    <BlockParallax
                        fixed
                        speed="12"
                        direction="top"
                        transform="translateY"
                        class="block-parents__img-box block-parents__img-box-two"
                    >
                        <img
                            srcset="../assets/parents-2.jpg, ../assets/parents-2@2x.jpg 2x"
                            src="../assets/parents-2.jpg"
                            class="block-parents__img"
                        >
                    </BlockParallax>
                </div>
            </div>
            <BlockParallax class="block-parents__icon block-parents__cup block-parents--icon-desktop" speed="11">
                <img src="@/assets/images/icons/1517-cup.png">
            </BlockParallax>
            <BlockParallax class="block-parents__icon block-parents__book block-parents--icon-desktop" speed="9">
                <img src="@/assets/images/icons/1517-book.png">
            </BlockParallax>
        </div>
    </div>
</template>

<script>
import BlockParallax from '@/components/blocks/parallax'

export default {
    components: {
        BlockParallax
    }
}
</script>

<style scoped lang="stylus">
    .block-parents {
        margin-top 3rem
        position relative
        +layout-md-and-up() {
            margin-top 6rem
        }
        &__body {
            position relative
            +layout-md-and-up() {
                display flex
            }
        }
        &__box-one {
            margin-top 2.2rem
            +layout-md-and-up() {
                display: flex
            }
            +layout-md-and-up() {
                padding-left: 8rem
            }
        }
        &__box-two {
            +layout-md-and-up() {
                display: flex
                flex-direction row-reverse
                margin-left: -6rem
            }
        }
        &__title {
            padding 0 2rem 0 5rem
            font-size 2.2rem
            line-height 2.6rem
            margin-top 0
            color $color-text
            font-weight $font-semiBold
            display block
            +layout-sm-and-up() {
                text-align: center
                padding: 0
            }
            +layout-md-and-up() {
                font-size 3rem
                margin-top 0.5rem
                line-height 3.5rem
                text-align left
                padding-left: 8rem

            }

        }
        &__text {
            padding 0 2rem 0 5rem
            font-size 1.5rem
            line-height 1.47
            margin 1.6rem 0 0 0
            +layout-md-and-up() {
                max-width 35rem
                padding: 0
            }
        }
        &__text-one {

        }
        &__text-two {
            +layout-md-and-up() {
                max-width 34rem
            }
        }
        &__img-box-one {
            margin-left -1rem
            margin-right -1rem
            margin-top 2rem
            +layout-sm-and-up() {
                max-width 46rem
                margin-left auto
            }
            +layout-md-and-up() {
                margin-top -9rem
                margin-left 5rem
            }
        }
        &__img-box-two {
            padding-left 3rem
            margin-right -1rem
            margin-top 2.5rem
            +layout-sm-and-up() {
                max-width 46rem
                margin-left: auto
                margin-right: auto
                padding-left: 0
            }
            +layout-md-and-up() {
                margin-left 6rem
                margin-top 9rem
            }
        }
        &__img {
            width: 100%
            margin-left auto
            display block
            +layout-sm-and-up() {
                align-self flex-start
                margin-right: 0
            }
        }

        &__icon {
            position absolute
            pointer-events none
            user-select none
        }
        &--icon-desktop {
            display none
            +layout-md-and-up() {
                display block
            }
        }

        &__cup {
            +layout-md-and-up() {
                bottom 18rem
                left -6rem
                width 9rem
            }
        }
        &__book {
            +layout-md-and-up() {
                bottom 6rem
                right 2rem
                width 11rem
            }
        }
    }
</style>
